import { useQuery } from '@tanstack/react-query';
import type { SashDto } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface CatalogueSashesApiResponse {
  success: boolean;
  data: SashDto[];
}

/**
 * Hook to fetch sashes for a specific material, windowType, and series.
 * Calls GET /catalogue/sashes?materialId={id}&windowTypeId={id}&seriesId={id}
 */
export function useSashes(materialId?: number, windowTypeId?: number, seriesId?: number) {
  return useQuery({
    queryKey: queryKeys.catalogue.sashes(materialId, windowTypeId, seriesId),
    queryFn: async () => {
      const response = await apiClient.get<CatalogueSashesApiResponse>('/catalogue/sashes', {
        params: { materialId, windowTypeId, seriesId },
      });
      return response.data.data;
    },
    enabled: !!materialId && !!windowTypeId && !!seriesId,
    staleTime: 5 * 60 * 1000,
  });
}
